import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { lihueConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={lihueConfig} />;
}